var e4        = e4 || {},
    eurowater = eurowater || {};
( function () {
    'use strict';
    eurowater.productDetailsPdf = {
        loaded: false,
        settings: {
            pdfmakeVersion: '0.1.62',
            pdfmakeUrl: {
                url: '/files/templates/designs/eurowater/_assets/js/vendor/pdfmake.min.js?v=1', 
                fallback: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.2.2/pdfmake.min.js', //OLD: '//cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.62/pdfmake.js',
                callback: null
            },
            vfsfontsUrl: {
                url: '/files/templates/designs/eurowater/_assets/js/vendor/vfs_fonts.js',
                fallback: '//cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.62/vfs_fonts.js',
                callback: null
            },
            pageWidth: 595.28,
            pageMargins: {
                left: 50,
                top: 35,
                right: 50,
                bottom: 50
            },
            columnImageGap: 10
        },
        model: {
            get: function ( key ) {
                return eurowater.pdfUtils.model.get( key, eurowater.productDetailsPdf.model );
            },
            set: function ( key, value ) {
                return eurowater.pdfUtils.model.set( key, value, eurowater.productDetailsPdf.model );
            },
            logo: '',
            referenceNumber: '',
            bottomLinkText: '',
            bottomLinkUrl: '',
            headline: '',
            images: {},
            mainText: '',
            linkText: '',
            url: '',
            tech: [],
            industry: [],
            application: [],
            unitInPlant: [],
            translations: []
        },
        init: function () {
            if ( Object.keys( window.eurowaterPDFData ).length > 0 ) {
                eurowater.productDetailsPdf.productData.get();
                eurowater.productDetailsPdf.bindEvents();
            }
        },
        bindEvents: function () {
            jQuery( '.js-generate-page-pdf' ).on( 'click', function ( event ) {
                event.preventDefault();
                if ( eurowater.productDetailsPdf.loaded === false ) {
                    eurowater.pdfUtils.load( eurowater.productDetailsPdf.prepareImages.init );
                }
                else {
                    eurowater.productDetailsPdf.build();
                }
            } );
        },
        productData: {
            get: function () {
                var productData = window.eurowaterPDFData;
                eurowater.productDetailsPdf.productData.map( productData );
            },
            map: function ( productData ) {
                for ( var key in productData ) {
                    if ( eurowater.productDetailsPdf.model.hasOwnProperty( key ) === true ) {
                        eurowater.productDetailsPdf.model.set( key, productData[ key ] );
                    }
                }
                var imageArr                             = eurowater.productDetailsPdf.model.get( 'images' );
                eurowater.productDetailsPdf.model.images = imageArr.reduce( function ( obj, item, depth ) {
                    obj[ 'index' + depth ] = {
                        img: item.replace( '/admin/public/getimage.ashx?Crop=0&amp;Image=', '' ).replace( '&amp;Format=jpg&amp;Width=1440&amp;Height=0&amp;Quality=75', '' )
                    };
                    return obj;
                }, {} );
            }
        },
        prepareImages: {
            deferredImages: [],
            init: function () {
                var logo   = {
                        key: 'logo',
                        img: eurowater.productDetailsPdf.model.get( 'logo' ),
                        size: 800
                    },
                    images = {
                        key: 'images',
                        img: eurowater.productDetailsPdf.model.get( 'images' ),
                        size: 1200
                    };
                eurowater.pdfUtils.loader( true );
                if ( logo.img.indexOf( 'data:image/png;base64' ) === -1 ) {
                    eurowater.productDetailsPdf.prepareImages.deferredImages.push( eurowater.productDetailsPdf.prepareImages.load( logo, false ) );
                }
                jQuery.each( images.img, function ( index ) {
                    if ( index !== undefined && index !== '' ) {
                        var imageObj = {
                            key: 'images',
                            index: index,
                            img: images.img[ index ].img,
                            size: index.indexOf( '0' ) > -1 ? images.size : images.size / 2
                        };
                        eurowater.productDetailsPdf.prepareImages.deferredImages.push( eurowater.productDetailsPdf.prepareImages.load( imageObj, false ) );
                    }
                } );
                jQuery.when.apply( null, eurowater.productDetailsPdf.prepareImages.deferredImages ).done( function () {
                    eurowater.productDetailsPdf.prepareImages.deferredImages = [];
                    eurowater.productDetailsPdf.loaded                       = true;
                    eurowater.productDetailsPdf.build();
                } );
            },
            load: function ( imageObj, isSvg ) {
                var image    = new Image(),
                    deferred = jQuery.Deferred();
                if ( isSvg === true ) {
                    var serializer = new XMLSerializer();
                    jQuery.when( eurowater.svg.convert( imageObj.img ) ).done( function ( svg ) {
                        var cleanedSvg = eurowater.productDetailsPdf.prepareImages.updateSvg( svg.get( 0 ) );
                        eurowater.productDetailsPdf.prepareImages.insertIntoModel( imageObj, serializer.serializeToString( cleanedSvg ) );
                        deferred.resolve();
                    } );
                }
                else {
                    image.onload  = function () {
                        var canvas      = document.createElement( 'canvas' );
                        canvas.width    = this.naturalWidth;
                        canvas.height   = this.naturalHeight;
                        imageObj.width  = this.naturalWidth;
                        imageObj.height = this.naturalHeight;
                        canvas.getContext( '2d' ).drawImage( this, 0, 0 );
                        eurowater.productDetailsPdf.prepareImages.insertIntoModel( imageObj, canvas.toDataURL( 'image/png' ) );
                        deferred.resolve();
                    };
                    image.onerror = function () {
                        var fallbackImage = eurowater.pdfUtils.image.fallback();
                        eurowater.productDetailsPdf.prepareImages.insertIntoModel( imageObj, fallbackImage );
                        deferred.resolve();
                    };
                    image.src     = eurowater.pdfUtils.image.handler( imageObj.img, imageObj.size, 0 );
                }
                return deferred.promise();
            },
            insertIntoModel: function ( imageObj, dataUri ) {
                if ( imageObj.index ) {
                    var objer = {
                        size: {
                            width: imageObj.width,
                            height: imageObj.height
                        }
                    };
                    eurowater.productDetailsPdf.model.set( imageObj.key + '.' + imageObj.index + '.img', dataUri );
                    eurowater.productDetailsPdf.model.set( imageObj.key + '.' + imageObj.index + '.size', {
                        width: imageObj.width,
                        height: imageObj.height
                    } );
                }
                else {
                    eurowater.productDetailsPdf.model.set( imageObj.key, dataUri );
                }
            },
            updateSvg: function ( svg ) {
                var elements = svg.querySelectorAll( 'path, polyline, polygon' );
                for ( var i = 0; i < elements.length; i++ ) {
                    elements[ i ].setAttribute( 'style', 'fill:#6D6F70!important' );
                }
                return svg;
            }
        },
        constructor: {
            header: function () {
                var bodyData = [],
                    dataRow  = [];
                dataRow.push( {
                    text: eurowater.productDetailsPdf.model.get( 'translations.referenceText' ) + ' ' + eurowater.productDetailsPdf.model.get( 'referenceNumber' ),
                    margin: [
                        0,
                        10,
                        0,
                        0
                    ],
                    style: 'RobotoBoldYellow'
                }, eurowater.pdfUtils.build.image( eurowater.productDetailsPdf.model.get( 'logo' ), 200, [
                    0,
                    0,
                    0,
                    0
                ], 'right' ) );
                bodyData.push( dataRow );
                return bodyData;
            },
            images: function () {
                var dataColumns = [],
                    dataStack   = [],
                    counter     = 0,
                    images      = eurowater.productDetailsPdf.model.get( 'images' ),
                    largeImageWidth = eurowater.pdfUtils.math.imageWidth( '2/3', true ),
                    largeImageHeight = 0,
                    ratio = 0,
                    smallImageWidth = eurowater.pdfUtils.math.imageWidth( '1/3', true );
                jQuery.each( images, function ( key ) {
                    if ( counter === 0 ) {
                        largeImageHeight = (largeImageWidth / images[ key ].size.width) * images[ key ].size.height;
                        ratio = largeImageWidth / largeImageHeight;
                        
                        dataColumns.push( eurowater.pdfUtils.build.image( images[ key ].img, largeImageWidth ) );
                    }
                    else if ( counter > 0 && counter < 3 ) {
                        var smallImageTargetHeight = (largeImageHeight - eurowater.productDetailsPdf.settings.columnImageGap) / 2;
                        dataStack.push( eurowater.pdfUtils.build.image( images[ key ].img, smallImageWidth, [
                            0,
                            0,
                            0,
                            eurowater.productDetailsPdf.settings.columnImageGap
                        ], 'right', null, smallImageTargetHeight ) );
                    }
                    counter++;
                } );
                if ( dataStack.length ) {
                    dataColumns.push( { stack: dataStack } );
                }
                return dataColumns;
            },
            boxes: function () {
                var techCount     = eurowater.productDetailsPdf.model.get( 'tech' ).length,
                    unitsCount    = eurowater.productDetailsPdf.model.get( 'unitInPlant' ).length,
                    maxLines      = Math.max( techCount, unitsCount ),
                    baseYposition = 760;
                for ( var i = 0; i < maxLines; i++ ) {
                    baseYposition -= 20;
                }
                return {
                    absolutePosition: {
                        x: eurowater.productDetailsPdf.settings.pageMargins.left,
                        y: baseYposition
                    },
                    layout: eurowater.pdfUtils.cleanTableLayout(),
                    table: {
                        widths: [
                            ( eurowater.pdfUtils.math.pageWidth( false ) / 2 ) - 0.5,
                            1,
                            ( eurowater.pdfUtils.math.pageWidth( false ) / 2 ) - 0.5
                        ],
                        body: [
                            [
                                {
                                    text: eurowater.productDetailsPdf.model.get( 'translations.techHeader' ),
                                    style: 'RobotoBold',
                                    fillColor: '#eeece1',
                                    margin: [
                                        10,
                                        10,
                                        10,
                                        0
                                    ]
                                },
                                {
                                    text: ' ',
                                    fillColor: '#ffffff'
                                },
                                {
                                    text: eurowater.productDetailsPdf.model.get( 'translations.unitsHeader' ),
                                    style: 'RobotoBold',
                                    fillColor: '#eeece1',
                                    margin: [
                                        10,
                                        10,
                                        10,
                                        0
                                    ]
                                }
                            ],
                            [
                                {
                                    ul: eurowater.productDetailsPdf.model.get( 'tech' ),
                                    margin: [
                                        15,
                                        0,
                                        10,
                                        10
                                    ],
                                    lineHeight: 1.2,
                                    style: 'RobotoRegular',
                                    fillColor: '#eeece1'
                                },
                                {
                                    text: ' ',
                                    fillColor: '#ffffff'
                                },
                                {
                                    ul: eurowater.productDetailsPdf.model.get( 'unitInPlant' ),
                                    margin: [
                                        15,
                                        0,
                                        10,
                                        10
                                    ],
                                    lineHeight: 1.2,
                                    style: 'RobotoRegular',
                                    fillColor: '#eeece1'
                                }
                            ]
                        ]
                    }
                };
            }
        },
        build: function () {
            var arrPdf     = [],
                mainText   = eurowater.pdfUtils.interpreter.list( eurowater.productDetailsPdf.model.get( 'mainText' ) ),
                objContent = [
                    {
                        layout: eurowater.pdfUtils.cleanTableLayout(),
                        margin: [
                            0,
                            0,
                            0,
                            15
                        ],
                        table: {
                            widths: [
                                '*',
                                '*'
                            ],
                            body: eurowater.productDetailsPdf.constructor.header()
                        }
                    },
                    {
                        columns: eurowater.productDetailsPdf.constructor.images(),
                        columnGap: eurowater.productDetailsPdf.settings.columnImageGap
                    },
                    {
                        layout: eurowater.pdfUtils.cleanTableLayout(),
                        margin: [
                            0,
                            15,
                            0,
                            0
                        ],
                        table: {
                            widths: [
                                'auto',
                                '*'
                            ],
                            body: [
                                [
                                    {
                                        text: eurowater.productDetailsPdf.model.get( 'translations.industryText' ),
                                        style: 'RobotoBoldYellow'
                                    },
                                    {
                                        text: eurowater.productDetailsPdf.model.get( 'industry' ).join(''),
                                        fontSize: 9,
                                        margin: [
                                            3,
                                            0,
                                            0,
                                            0
                                        ]
                                    }
                                ]
                            ]
                        }
                    },
                    {
                        layout: eurowater.pdfUtils.cleanTableLayout(),
                        table: {
                            widths: [
                                'auto',
                                '*'
                            ],
                            body: [
                                [
                                    {
                                        text: eurowater.productDetailsPdf.model.get( 'translations.applicationText' ),
                                        style: 'RobotoBoldYellow'
                                    },
                                    {
                                        text: eurowater.productDetailsPdf.model.get( 'application' ).join(''),
                                        fontSize: 9,
                                        margin: [
                                            3,
                                            0,
                                            0,
                                            10
                                        ]
                                    }
                                ]
                            ]
                        }
                    },
                    {
                        text: eurowater.productDetailsPdf.model.get( 'headline' ),
                        margin: [
                            0,
                            10,
                            0,
                            10
                        ],
                        style: 'header'
                    },
                    mainText.beforeText,
                    mainText.listText,
                    mainText.afterText,
                    {
                        //text: eurowater.productDetailsPdf.model.get( 'bottomLinkText' ),
                        text: (eurowater.productDetailsPdf.model.get( 'bottomLinkUrl' ).indexOf("youtu") >= 0 ? "" : eurowater.productDetailsPdf.model.get( 'bottomLinkText' ) ),
                        //link: eurowater.productDetailsPdf.model.get( 'bottomLinkUrl' ),
                        link: (eurowater.productDetailsPdf.model.get( 'bottomLinkUrl' ).indexOf("youtu") >= 0 ? "" : eurowater.productDetailsPdf.model.get( 'bottomLinkUrl' ) ),
                        style: 'RobotoLink'
                    },
                    eurowater.productDetailsPdf.constructor.boxes()
                ];
            arrPdf.push( objContent );
            eurowater.productDetailsPdf.create( arrPdf );
        },
        create: function ( arrPdf ) {
            pdfMake.fonts       = eurowater.pdfUtils.setFont();
            var docDefinition   = {
                    pageSize: 'A4',
                    pageMargins: [
                        eurowater.productDetailsPdf.settings.pageMargins.left,
                        eurowater.productDetailsPdf.settings.pageMargins.top,
                        eurowater.productDetailsPdf.settings.pageMargins.right,
                        eurowater.productDetailsPdf.settings.pageMargins.bottom
                    ],
                    content: arrPdf,
                    fonts: eurowater.pdfUtils.setFont(),
                    footer: eurowater.pdfUtils.build.footer(),
                    defaultStyle: {
                        font: 'Roboto'
                    },
                    styles: eurowater.pdfUtils.styles.default()
                },
                pdfDocGenerator = pdfMake.createPdf( docDefinition, null, eurowater.pdfUtils.setFont() );
            pdfDocGenerator.download( 'Eurowater_reference' + eurowater.productDetailsPdf.model.get( 'referenceNumber' ).replace( / /g, '_' ) + '.pdf' );
            pdfDocGenerator.getDataUrl( function () {
                eurowater.pdfUtils.loader( false );
            } );
        }
    };
    eurowater.pdfUtils          = {
        load: function ( fnCallback ) {
            //Load vendor-scripts for pdf-generator - nested as the pdfMake.js needs to load first
            e4.util.require.js( eurowater.productDetailsPdf.settings.pdfmakeUrl, function () {
                e4.util.require.js( eurowater.productDetailsPdf.settings.vfsfontsUrl, function () {
                    if ( typeof fnCallback === 'function' ) {
                        fnCallback();
                    }
                } );
            } );
        },
        model: {
            get: function ( key, model ) {
                if ( key.indexOf( '.' ) === -1 ) {
                    return model[ key ];
                }
                else if ( key.indexOf( '.' ) > -1 ) {
                    var objSource     = model,
                        arrProperties = key.split( '.' ),
                        objReturnValue;
                    for ( var i = 0; i < arrProperties.length; i++ ) {
                        var strCurrentPropertyName                 = arrProperties[ i ],
                            strRemainingPropertyPathAsPropertyName = arrProperties.slice( i ).join( '.' );
                        if ( objSource.hasOwnProperty( strRemainingPropertyPathAsPropertyName ) === true ) {
                            objReturnValue = objSource[ strRemainingPropertyPathAsPropertyName ];
                            break;
                        }
                        else {
                            if ( objSource.hasOwnProperty( strCurrentPropertyName ) === true ) {
                                objSource = objSource[ strCurrentPropertyName ];
                            }
                            else {
                                objReturnValue = undefined;
                                break;
                            }
                        }
                    }
                    return objReturnValue;
                }
            },
            set: function ( key, value, model ) {
                if ( key.indexOf( '.' ) === -1 ) {
                    model[ key ] = value;
                }
                else if ( key.indexOf( '.' ) > -1 ) {
                    var arrProperties = key.split( '.' );
                    return arrProperties.reduce( function ( objPropertyPath, strCurrentPropertyName, intPropertyPathDepth ) {
                        if ( intPropertyPathDepth === arrProperties.length - 1 ) {
                            objPropertyPath[ strCurrentPropertyName ] = value;
                        }
                        else {
                            if ( objPropertyPath.hasOwnProperty( strCurrentPropertyName ) === false ) {
                                objPropertyPath[ strCurrentPropertyName ] = {};
                            }
                        }
                        return objPropertyPath[ strCurrentPropertyName ];
                    }, model );
                }
            }
        },
        image: {
            getDataUri: function ( strUrl, fnCallback ) {
                var image     = new Image();
                image.onload  = function () {
                    var canvas    = document.createElement( 'canvas' );
                    canvas.width  = this.naturalWidth;
                    canvas.height = this.naturalHeight;
                    canvas.getContext( '2d' ).drawImage( this, 0, 0 );
                    if ( typeof fnCallback === 'function' ) {
                        fnCallback( canvas.toDataURL( 'image/png' ) );
                    }
                };
                image.onerror = function () {
                    if ( typeof fnCallback === 'function' ) {
                        fnCallback( eurowater.pdfUtils.image.fallback() );
                    }
                };
                image.src     = strUrl;
            },
            handler: function ( image, width, height ) {
                if ( image.indexOf( '.svg' ) > -1 ) {
                    return image;
                }
                return '/admin/public/getimage.ashx?crop=0&image={image}&Height={height}&Width={width}&Quality=90&format=png'.replace( '{image}', image ).replace( '{width}', width ).replace( '{height}', height );
            },
            fallback: function () {
                return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
            }
        },
        interpreter: {
            list: function ( strText ) {
                var returnResult = {
                    beforeText: '',
                    listText: '',
                    afterText: ''
                };
                if ( strText.indexOf( '<ul>' ) > -1 ) {
                    returnResult.beforeText = {
                        text: strText.substring( 0, strText.indexOf( '<ul>' ) ),
                        style: 'bodyCopy'
                    };
                    var listText            = strText.substring( strText.indexOf( '<ul>' ), ( strText.indexOf( '</ul>' ) + 5 ) );
                    var listArr             = listText.replace( '<ul>', '' ).replace( '</ul>', '' ).split( '</li>' );
                    var listObj             = {
                        ul: [],
                        margin: [
                            15,
                            10,
                            10,
                            10
                        ],
                        lineHeight: 1.2,
                        style: 'bodyCopy'
                    };
                    listArr.forEach( function ( elm ) {
                        if ( elm.length ) {
                            listObj.ul.push( elm.replace( '<li>', '' ) );
                        }
                    } );
                    returnResult.listText  = listObj;
                    returnResult.afterText = {
                        text: strText.substring( ( strText.indexOf( '</ul>' ) + 5 ), strText.length ),
                        style: 'bodyCopy'
                    }
                }
                else {
                    returnResult.beforeText = {
                        text: strText,
                        style: 'bodyCopy'
                    };
                }
                
                try {
                    //STRIP HTML TAGS FROM TEXT
                    var div = document.createElement("div");
                    div.innerHTML = returnResult.beforeText.text;
                    returnResult.beforeText.text = div.innerText;
                } catch(ex) {
                    //USING ORIGINAL TEXT
                }
                
                return returnResult
            }
        },
        math: {
            pageWidth: function ( isImage ) {
                return eurowater.productDetailsPdf.settings.pageWidth - ( eurowater.productDetailsPdf.settings.pageMargins.left + eurowater.productDetailsPdf.settings.pageMargins.right ) - ( isImage ? eurowater.productDetailsPdf.settings.columnImageGap : 0 );
            },
            imageWidth: function ( strWidth, isImage ) {
                var returnValue = 0,
                    pageWidth   = eurowater.pdfUtils.math.pageWidth( isImage );
                switch ( strWidth ) {
                    case '1':
                        returnValue = pageWidth;
                        break;
                    case '1/2':
                        returnValue = pageWidth / 2;
                        break;
                    case '1/3':
                        returnValue = pageWidth / 3;
                        break;
                    case '2/3':
                        returnValue = ( pageWidth / 3 ) * 2;
                        break;
                    case '1/4':
                        returnValue = pageWidth / 4;
                        break;
                    default:
                        returnValue = pageWidth;
                }
                return returnValue;
            }
        },
        cleanTableLayout: function () {
            return {
                hLineWidth: function () {
                    return 0;
                },
                vLineWidth: function () {
                    return 0;
                },
                paddingLeft: function () {
                    return 0;
                },
                paddingRight: function () {
                    return 0;
                }
            };
        },
        loader: function ( boolLoad ) {
            if ( boolLoad === true ) {
                jQuery( '.js-e-page-loading-overlay' ).addClass( 'is-loading' );
            }
            else {
                jQuery( '.js-e-page-loading-overlay' ).removeClass( 'is-loading' );
            }
        },
        setFont: function () {
            return {
                EBGaramond: {
                    normal: 'EBGaramond-Regular.ttf',
                    bold: 'EBGaramond-Regular.ttf',
                    italics: 'EBGaramond-Regular.ttf',
                    bolditalics: 'EBGaramond-Regular.ttf'
                },
                Roboto: {
                    normal: 'Roboto-Regular.ttf',
                    bold: 'Roboto-Bold.ttf',
                    italics: 'Roboto-Regular.ttf',
                    bolditalics: 'Roboto-Bold.ttf'
                }
            };
        },
        build: {
            image: function ( strImageUri, intWidth, arrMargin, strAlignment, strFillColor, intImgHeight ) {
                var objToReturn = {
                    image: strImageUri,
                    width: intWidth,
                    margin: arrMargin,
                    fillColor: strFillColor,
                    alignment: strAlignment
                };
                if(intImgHeight > 0) {
                    //IMAGE COVER IS AVAILABLE IN MAKEPDF.JS 0.2.2
                    objToReturn.cover = { width:  intWidth, height: intImgHeight };
                    objToReturn.height = intImgHeight;
                }
                return objToReturn;
            },
            svg: function ( strSvg, intWidth ) {
                return {
                    svg: strSvg,
                    width: intWidth
                };
            },
            line: function () {
                return {
                    canvas: [
                        {
                            type: 'line',
                            x1: 0,
                            y1: 0,
                            x2: eurowater.pdfUtils.math.pageWidth( false ),
                            y2: 0,
                            lineWidth: 1,
                            color: '#888888'
                        }
                    ]
                };
            },
            footer: function () {
                return [
                    {
                        alignment: 'center',
                        columns: [
                            {
                                text: eurowater.productDetailsPdf.model.get( 'translations.seeMoreText' ),
                                link: eurowater.productDetailsPdf.model.get( 'url' ),
                                alignment: 'right',
                                style: 'RobotoRegular',
                                margin: [
                                    0,
                                    10,
                                    0,
                                    0
                                ]
                            },
                            {
                                text: eurowater.productDetailsPdf.model.get( 'linkText' ),
                                link: eurowater.productDetailsPdf.model.get( 'url' ),
                                alignment: 'left',
                                style: {
                                    font: 'Roboto',
                                    fontSize: 9,
                                    color: '#00a1e7'
                                },
                                margin: [
                                    3,
                                    10,
                                    0,
                                    0
                                ]
                            }
                        ]
                    }
                ];
            }
        },
        styles: {
            default: function () {
                return {
                    header: {
                        fontSize: 20,
                        font: 'EBGaramond'
                    },
                    RobotoBoldYellow: {
                        font: 'Roboto',
                        fontSize: 9,
                        bold: true,
                        color: '#eb9128'
                    },
                    RobotoLink: {
                        font: 'Roboto',
                        fontSize: 10,
                        bold: true,
                        color: '#f28b2d'
                    },
                    RobotoBold: {
                        font: 'Roboto',
                        fontSize: 9,
                        bold: true
                    },
                    RobotoRegular: {
                        font: 'Roboto',
                        fontSize: 9
                    },
                    bodyCopy: {
                        font: 'Roboto',
                        fontSize: 10
                    },
                    bold: {
                        bold: true
                    },
                    small: {
                        fontSize: 8
                    }
                };
            }
        }
    };
}() );
